/**
 * MetricList
 * @author Zhan Yang
 */
import React, { useState } from 'react';

import AntdIcon from '@ant-design/icons';

export const Icon: React.FC<any> = (props) => {
  const [isHover, setHover] = useState<boolean>(false);
  const { activeComponent, component, ...rests } = props;
  const onMouseOver = () => {
    setHover(true);
  };
  const onMouseleave = () => {
    setHover(false);
  };
  const icon = isHover ? activeComponent || component : component;
  return (
    <AntdIcon onMouseOver={onMouseOver} onMouseLeave={onMouseleave} {...rests} component={icon} />
  );
};
